<template>
  <div class="container-fluid bg-survey-conclusion-top text-gray03">
    <div class="row">
      <div class="col-sm-12">
        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeInDown"
        >
          <div v-if="loaded" class="card text-center card-survey">
            <h3
              ref="surveyConclusion"
              class="medium mt-2"
              tabindex="1"
              :title="resources.page.survey.conclusion.description"
            >
              {{ resources.page.survey.conclusion.title }}
            </h3>
            <div v-if="$can('use', 'libras')">
              <video-player
                :videoSource="
                  `https://static.teamculture.com.br/libras/low/Encerramento.mp4`
                "
              />
            </div>
            <h5 class="regular" v-if="$can('use', 'libras')">
              {{ resources.page.survey.conclusion.description }}
            </h5>
            <h4 class="regular" v-else>
              {{ resources.page.survey.conclusion.description }}
            </h4>
            <!-- <div class="custom-poll-wrapper">
              <div v-if="onGoingLoading" class="loading" aria-hidden="true">
                <loading-state />
              </div>
              <div v-else>
                <div class="row mt-4 mb-4" aria-hidden="true">
                  <div class="col" aria-hidden="true">
                    <b-button
                      tabindex="-1"
                      aria-hidden="true"
                      class="btn-block"
                      variant="secondary"
                      id="btn-confirm"
                      :to="{ name: 'dashboard' }"
                    >
                      {{ resources.general.buttons.backToHome }}
                    </b-button>
                  </div>
                </div>

                <template v-if="pollsPending.length" aria-hidden="true">
                  <hr />
                  <div class="row mt-1 mb-1" aria-hidden="true">
                    <h5
                      class="col col-12 mb-4"
                      v-if="pollsPending.length === 1"
                    >
                      {{ resources.page.survey.conclusion.youHavePendingPoll }}
                    </h5>
                    <h5 class="col col-12 mb-4" v-else>
                      {{
                        resources.page.survey.conclusion.youHavePendingPolls
                          | parse({ POLLS_LENGTH: pollsPending.length })
                      }}
                    </h5>
                  </div>

                  <div
                    aria-hidden="true"
                    class="row mt-1 mb-1 border-top"
                    v-for="poll in pollsPending"
                    :key="poll.poll_id"
                  >
                    <div class="col self-align-center" aria-hidden="true">
                      {{ poll.title }}
                    </div>
                    <div class="col col-4" aria-hidden="true">
                      <b-button
                        aria-hidden="true"
                        class="btn btnAnswer"
                        variant="secondary"
                        @click="goToCustomPoll(poll.poll_id)"
                      >
                        {{ resources.page.survey.conclusion.answerNow }}
                      </b-button>
                    </div>
                  </div>
                </template>
              </div>
            </div> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { getOnGoing } from '@/service/customPoll'
import { showChat } from '@/helpers/chat'
import VideoPlayer from '@/components/Survey/VideoPlayer.vue'

export default {
  components: {
    // 'loading-state': () => import('@/components/Shared/Loading.vue'),
    VideoPlayer,
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
  },
  data() {
    return {
      onGoingLoading: false,
      loaded: false,
      pollsPending: [],
    }
  },

  // preload images
  beforeRouteEnter(to, from, next) {
    const image = new Image()
    image.src = `${window.location.origin}/survey/ico-survey-conclusion.svg`
    setTimeout(() => next())
  },

  created() {
    setTimeout(() => {
      this.loaded = true
    })
  },

  mounted() {
    if (!this.$can('use', 'libras')) {
      // this.onGoingLoading = true
      // getOnGoing()
      //   .then(polls => (this.pollsPending = polls))
      //   .finally(() => {
      //     this.onGoingLoading = false
      //     this.$nextTick(() => {
      //       this.$refs.surveyConclusion.focus()
      //     })
      //   })
      this.$refs.surveyConclusion.focus()
    }
  },

  updated() {
    showChat()
  },

  methods: {
    goToCustomPoll(pollId) {
      this.$root.$emit('track', {
        event: 'survey',
        data: {
          message: 'navegou do survey para a pesquisa personalizada',
        },
      })
      this.$router.push({
        name: 'customPollSurvey.initial',
        params: { pollId: pollId },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.border-top {
  background: map-get($theme-colors, 'denary');
  padding: 5px;
}

.self-align-center {
  align-self: center;
}

.loading {
  margin: 0 auto;
  text-align: center;
  font-size: 13px;

  /deep/ .lds-ellipsis {
    height: 20px;

    div {
      background-color: map-get($theme-colors, 'gray03');
      height: 8px;
      top: 10px;
      width: 8px;
    }
  }
}

.card-survey {
  display: flex;
  justify-content: center;
  max-width: 80%;
  margin: 50px auto;
  min-height: 70vh;
  padding: 100px;

  @media (max-width: 767px) {
    padding-top: 15px;
  }

  .btn {
    align-items: center;
    display: flex;
    justify-content: center;
    max-width: 380px;
    margin: 0 auto;

    &.btn-light {
      border: 1px solid #b7b8bb;
    }
  }

  h3 {
    color: map-get($theme-colors, 'primary');
    font-size: 42px;

    @media (max-width: 767px) {
      font-size: 24px;
    }
  }

  h4 {
    font-size: 30px;

    @media (max-width: 767px) {
      font-size: 18px;
    }
  }

  // SMALL
  @media (max-width: 767px) {
    border: 0px solid;
    max-width: initial;
    padding: 90px 20px 20px;

    .responsive {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  &::before {
    content: ' ';
    width: 100%;
    height: 200px;
    background-image: url('/survey/ico-survey-conclusion.svg');
    position: absolute;
    background-position: center;
    text-align: center;
    background-repeat: no-repeat;
    left: 0;
    background-size: contain;
    top: -100px;

    @media (max-width: 767px) {
      height: 80px;
      top: -40px;
    }
  }
}

.bg-survey-conclusion-top {
  background-image: url('/survey/bg-survey.jpg');
  background-position: top;
  background-repeat: no-repeat;
  min-height: 100%;
  margin: 0 auto;
  padding-top: 80px;
  background-color: map-get($theme-colors, 'light');
  background-size: cover;

  @media (max-width: 767px) {
    padding-top: 20px;
  }
}
</style>
